module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ApplyView.js"));
	}, "RelationApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RelationApplyView!./src/pages/Promote/BusinessHall/AlterRelation/Apply/ApplyView.js
// module id = 1125
// module chunks = 438